import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import Dialog from 'components/dialog'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'

const StatusModal = ({ text, open, setOpen, toggleStatus }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const classes = useDialogTitleStyles()

  const handleConfirm = async () => {
    setLoading(true)
    setError(false)
    try {
      await toggleStatus(setOpen, setLoading, setError)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog
      isOpen={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="xs"
      showCloseButton
      disableClose={loading}
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          {loading ? <LinearProgress /> : null}
          {error ? (
            <Typography color="error" style={{ padding: '16px 24px 0' }}>
              Oops! Something went wrong, please try again later.
            </Typography>
          ) : null}
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              {text.title}
            </Typography>
          </DialogTitle>
          <DialogContent classes={{ root: classes.content }}>
            <Typography className={classes.bodyText}>{text.body1}</Typography>
            <Typography className={classes.bodyText} style={{ marginTop: 12 }}>
              {text.body2}
            </Typography>
          </DialogContent>
          <DialogActions className={classes.actions}>
            <Button onClick={closeDialog} disabled={loading} color="primary">
              Cancel
            </Button>
            <Button
              onClick={handleConfirm}
              disabled={loading}
              variant="contained"
              color="primary"
            >
              {text.confirmLabel || 'Yes'}
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

StatusModal.propTypes = {
  text: PropTypes.shape({
    title: PropTypes.string,
    body1: PropTypes.string,
    body2: PropTypes.string,
    confirmLabel: PropTypes.string,
  }),
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  toggleStatus: PropTypes.func,
}

export default StatusModal
